import { normalizePublicLanguage } from "@/lib/publicLanguage";

function translatedValue(translations, language, fallback = "") {
  const normalized = normalizePublicLanguage(language);
  return translations?.[normalized] || translations?.en || fallback;
}

export function localizeCategory(category, language) {
  if (!category) return category;
  return {
    ...category,
    name: translatedValue(category.name_translations, language, category.name),
    description: translatedValue(
      category.description_translations,
      language,
      category.description
    ),
  };
}

export function localizeProduct(product, language) {
  if (!product) return product;
  const localizedSpecs =
    translatedValue(product.specifications_translations, language, null) ||
    product.specifications ||
    [];

  return {
    ...product,
    name: translatedValue(product.name_translations, language, product.name),
    description: translatedValue(
      product.description_translations,
      language,
      product.description
    ),
    short_description: translatedValue(
      product.short_description_translations,
      language,
      product.short_description
    ),
    moq: translatedValue(product.moq_translations, language, product.moq),
    price_range: translatedValue(
      product.price_range_translations,
      language,
      product.price_range
    ),
    origin_country: translatedValue(
      product.origin_country_translations,
      language,
      product.origin_country
    ),
    specifications: localizedSpecs,
  };
}

export function localizeCategories(items, language) {
  return (items || []).map((item) => localizeCategory(item, language));
}

export function localizeProducts(items, language) {
  return (items || []).map((item) => localizeProduct(item, language));
}
